// extracted by mini-css-extract-plugin
export default {"select__wrraper":"style_select__wrraper__Z16Ct"};